module.exports = __webpack_public_path__ + "static/media/url-icon.927889e8.svg";